import { Injectable } from '@angular/core';
import { Router }     from '@angular/router';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { Angular2TokenService } from 'angular2-token';
import { Observable }           from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import { UserDetailsService } from '../services/user-details.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AuthService {
  redirectUrl: string;
  headers: Headers;
  options: RequestOptions;
  currentUserDetails: any;

  constructor(
    private tokenService: Angular2TokenService,
    public router: Router,
    private userDetailService: UserDetailsService,
    private http: Http,
    ) {
    }

  logIn(email: string, password: string): Observable<Response> {
    
    return this.tokenService.signIn({ email: email,
                                     password: password })
  }

  signUp(name: string, email: string, contact:string, password: string): Observable<Response> {

    return this.tokenService.registerAccount({  name: name,
                                                email: email,
                                                contact: contact,
                                                password: password,
                                                passwordConfirmation: password
                                                 });
  }

  resetPassword(email: string): Observable<Response> {
    return this.tokenService.resetPassword({
            email: email,
        });
  }

  signInWithGithub(): Observable<any> {
    return this.tokenService.signInOAuth('github');
  }

  proccessOauthCallback(): void {
    this.tokenService.processOAuthCallback();
    this.redirectAfterLogin();
  }

  logOut(): void {
    this.redirectUrl = undefined;
    this.tokenService.signOut();
    this.router.navigate(['/log-in']);
  }

  isLoggedIn(): boolean {
    return this.tokenService.userSignedIn();
  }

  // checkRole() : String {
  //   if(this.userDetailService.user_signed_in()){
  //     return this.userDetailService.current_user().role;
  //   }

  // }

  redirectAfterLogin(): void {
    // this.checkRole();
    console.log("test");
    let redirectTo = this.redirectUrl ? this.redirectUrl : '/';
    this.redirectUrl = undefined;
    this.router.navigate([redirectTo]);
  }

  getHeaders(): RequestOptions {
      this.headers = new Headers({'enctype': 'multipart/form-data'});
      this.headers.append('Accept', 'application/json');
      this.headers.append('uid', this.tokenService.currentAuthData.uid);
      this.headers.append('client', this.tokenService.currentAuthData.client);
      this.headers.append('access-token', this.tokenService.currentAuthData.accessToken);
      this.options = new RequestOptions({headers: this.headers});
      return this.options;
  }

  forgotPassword(data) {
    // let url = environment.apiBaseUrl+'/auth/password';
    // this.headers = new Headers({'enctype': 'multipart/form-data'});
    // this.headers.append('Accept', 'application/json');
    // this.options = new RequestOptions({headers: this.headers});
    // return this.http.post(url,data,this.options)
    //               .map(this.extractData)
    //               .catch(this.handleErrorObservable);
  }
  private extractData(res: Response) {
      let body = res.json();
      return body;
  }

  private handleErrorObservable (error: Response | any) {
    return Observable.throw(error.message || error);
  }
  


}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/authentication/auth.service.ts